<template>
  <div id="beforeAfterThree"></div>
</template>

<script>
export default {
  name: "BeforeAfterThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        beforeLabel: "Before",
        beforeValue: "12 hours",
        afterLabel: "After",
        afterValue: "30 minutes",
        context: "Time to complete monthly reports",
        chip: "Results",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("beforeAfterThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const valueSize = exporting ? 90 : 90 * this.scale;
      const labelSize = exporting ? 26 : 26 * this.scale;
      const contextSize = exporting ? 36 : 36 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const vsSize = exporting ? 48 : 48 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Before/After content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="
              font-size: ${contextSize}px;
              font-family: 'Playfair Display', 'Georgia', serif;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 1.3;
              margin-bottom: 48px;
              position: relative;
              display: inline-block;
            ">
              ${this.data.context}
              <span style="
                position: absolute;
                bottom: -12px;
                left: 0;
                width: 60%;
                height: 4px;
                background: ${primaryColor};
              "></span>
            </div>

            <div style="display: flex; align-items: flex-start; gap: 32px; margin-top: 24px;">
              <!-- Before -->
              <div style="flex: 1; background: #ffffff; padding: 32px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 600;
                  color: #999999;
                  margin-bottom: 16px;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                ">${this.data.beforeLabel}</div>
                <div style="
                  font-size: ${valueSize}px;
                  font-family: 'Playfair Display', 'Georgia', serif;
                  font-weight: 700;
                  color: #cccccc;
                  line-height: 1;
                  text-decoration: line-through;
                ">${this.data.beforeValue}</div>
              </div>

              <!-- VS -->
              <div style="
                font-size: ${vsSize}px;
                font-weight: 900;
                color: #1a1a1a;
                opacity: 0.1;
                padding-top: 60px;
              ">VS</div>

              <!-- After -->
              <div style="flex: 1; background: #1a1a1a; padding: 32px; border-radius: 8px;">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 600;
                  color: ${primaryColor};
                  margin-bottom: 16px;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                ">${this.data.afterLabel}</div>
                <div style="
                  font-size: ${valueSize}px;
                  font-family: 'Playfair Display', 'Georgia', serif;
                  font-weight: 700;
                  color: #ffffff;
                  line-height: 1;
                ">${this.data.afterValue}</div>
              </div>
            </div>

            <!-- Chip -->
            <div style="display: flex; margin-top: 40px;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
